import { UrlApi } from "../../../../../services/apirest";

export const getMailService = async (id) => {
  const response = await fetch(
    `${UrlApi}/comprobantes/direccionesDeEntrega/mails/envasado/${id}`,
  );

  if (!response.ok) {
    throw new Error("Error al obtener el mail");
  }

  return response.json();
};
